import Styles from './InlineFormatDivider.module.scss'

export const InlineFormatDivider = () => <hr className={Styles.divider} />
